import { createSlice } from "@reduxjs/toolkit";
import { getMuteStatus, toggleMute } from "../actions/pushMuteActions";
const initialState = {
  isMuted: null, // null until loaded; true|false afterwards
  loading: false,
  error: null,
  toggling: false,
  ensuring: false,
};

const slice = createSlice({
  name: "pushMute",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET mute
      .addCase(getMuteStatus.pending, (s) => {
        s.loading = true;
        s.error = null;
      })
      .addCase(getMuteStatus.fulfilled, (s, a) => {
        s.loading = false;
        s.isMuted = a.payload.is_muted;
      })
      .addCase(getMuteStatus.rejected, (s, a) => {
        s.loading = false;
        s.error = a.error.message;
      })

      // PATCH mute
      .addCase(toggleMute.pending, (s) => {
        s.toggling = true;
        s.error = null;
      })
      .addCase(toggleMute.fulfilled, (s, a) => {
        s.toggling = false;
        s.isMuted = !!a.payload.is_muted;
      })
      .addCase(toggleMute.rejected, (s, a) => {
        s.toggling = false;
        s.error = a.error.message;
      });
  },
});

export default slice.reducer;
